/* __next_internal_client_entry_do_not_use__ ResponsiveContentV2 auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import cn from "classnames";
import React from "react";
import { useViewport } from "../hooks/useViewport";
// eslint-disable-next-line import/no-unassigned-import
import "./native-styles.css";
/**
 * This component can be used to conditionally display content based on the viewport.
 *
 * If used with the "noJS" prop, if used as a React Server Component (RSC),
 * or during SSR, it will render all possible viewports,
 * hiding ones that do not apply using media queries.
 *
 * It is not valid to pass noJS={false} if rendered from a React Server Component (RSC).
 */ export var ResponsiveContentV2 = // eslint-disable-next-line complexity
function(props) {
    var mobile = props.mobile, tablet = props.tablet, desktop = props.desktop, xlarge = props.xlarge, xxlarge = props.xxlarge, tabletAndAbove = props.tabletAndAbove, tabletAndBelow = props.tabletAndBelow, desktopAndAbove = props.desktopAndAbove, xLargeAndAbove = props.xLargeAndAbove, noJS = props.noJS;
    var isSSR = useIsSSR();
    var viewport = useViewport();
    if (isSSR || noJS) {
        return /*#__PURE__*/ _jsx(StaticResponsiveContent, _object_spread_props(_object_spread({}, props), {
            noJS: true
        }));
    }
    if (viewport.isMobile && mobile) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: mobile
        });
    }
    if (viewport.isTablet && tablet) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: tablet
        });
    }
    if (viewport.isDesktop && desktop) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: desktop
        });
    }
    if (viewport.isXLargeDesktop && xlarge) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: xlarge
        });
    }
    if (viewport.isXXLargeDesktop && xxlarge) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: xxlarge
        });
    }
    if (viewport.isXLargeAndAbove && xLargeAndAbove) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: xLargeAndAbove
        });
    }
    if (viewport.isDesktopAndAbove && desktopAndAbove) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: desktopAndAbove
        });
    }
    if (viewport.isTabletAndAbove && tabletAndAbove) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: tabletAndAbove
        });
    }
    if (viewport.isTabletAndBelow && tabletAndBelow) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: tabletAndBelow
        });
    }
    return null;
};
var StaticResponsiveContent = function(props) {
    var mobile = props.mobile, tablet = props.tablet, desktop = props.desktop, xlarge = props.xlarge, xxlarge = props.xxlarge, tabletAndAbove = props.tabletAndAbove, tabletAndBelow = props.tabletAndBelow, desktopAndAbove = props.desktopAndAbove, xLargeAndAbove = props.xLargeAndAbove, noJS = props.noJS, flat = props.flat;
    if (noJS === false) {
        throw new Error("StaticResponsiveContent is being used as a React Server Component, but noJS was set to false.");
    }
    var wrap = function(content, className) {
        if (flat) {
            return React.Children.map(content, function(child) {
                return /*#__PURE__*/ React.cloneElement(child, {
                    className: cn(className, child.props.className)
                });
            });
        } else {
            return /*#__PURE__*/ _jsx("span", {
                className: className,
                children: content
            });
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            mobile ? wrap(mobile, "f_r_mobileOnly") : null,
            tablet ? wrap(tablet, "f_r_tabletOnly") : null,
            desktop ? wrap(desktop, "f_r_desktopOnly") : null,
            xlarge ? wrap(xlarge, "f_r_xLargeOnly") : null,
            xxlarge ? wrap(xxlarge, "f_r_xxLargeOnly") : null,
            tabletAndAbove ? wrap(tabletAndAbove, "f_r_tabletAndAbove") : null,
            tabletAndBelow ? wrap(tabletAndBelow, "f_r_tabletAndBelow") : null,
            desktopAndAbove ? wrap(desktopAndAbove, "f_r_desktopAndAbove") : null,
            xLargeAndAbove ? wrap(xLargeAndAbove, "f_r_xLargeAndAbove") : null
        ]
    });
};
